export const getProcurementDivisionType = (role) => {
  if (role === 'Price Memo Owner (Packaging)' || role === 'Price Memo Viewer (Packaging)') {
    return 'Packaging';
  }

  if (role === 'Price Memo Owner (CEPG)' || role === 'Price Memo Viewer (CEPG)') {
    return 'CEPG';
  }

  return 'SIS';
};
